import * as React from 'react';

import { useOpenFilters } from '../useOpenFilters';

const FILTER_CLICK_EVENT = 'filter:click';

export function useSearchStringFiltersClick(): void {
  const openFilters = useOpenFilters();

  React.useEffect(() => {
    window.addEventListener(FILTER_CLICK_EVENT, openFilters);

    return () => {
      window.removeEventListener(FILTER_CLICK_EVENT, openFilters);
    };
  }, [openFilters]);
}
